import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useRiskRegisterPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type RiskRegisterModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const RiskRegisterModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: RiskRegisterModalProps): JSX.Element => {
  const riskRegisterPermalink = useRiskRegisterPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.RISKS]: {
          ...context[ChatContextSourceType.RISKS],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={riskRegisterPermalink}>risk register</ExternalLink>
      </p>
    ),
    [riskRegisterPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Risk Register"
      description={description}
      prompt="Do consider risk register"
      currentSelection={context[ChatContextSourceType.RISKS].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
